import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SustainabilityState } from '../states/sustainability.state';

const sustainabilityFeatureSelector = createFeatureSelector<SustainabilityState>('sustainability');

export const sustainabilitySelectors = {
  carbonTrackError: createSelector(sustainabilityFeatureSelector, (state) => state.carbonTrack.error),
  carbonTrackFilters: createSelector(sustainabilityFeatureSelector, (state) => state.carbonTrack.filters),
  carbonTrackData: createSelector(sustainabilityFeatureSelector, (state) => state.carbonTrack.data),
  originWarrantyError: createSelector(sustainabilityFeatureSelector, (state) => state.originWarranty.error),
  originWarrantyFilters: createSelector(sustainabilityFeatureSelector, (state) => state.originWarranty.filters),
  originWarrantyData: createSelector(sustainabilityFeatureSelector, (state) => state.originWarranty.data),
  // SUSTAINABILITY-SUMMARY
  summaryCarbonTrackFilters: createSelector(sustainabilityFeatureSelector, (state) => state.summaryCarbonTrack.filters),
  summaryCarbonTrackData: createSelector(sustainabilityFeatureSelector, (state) => state.summaryCarbonTrack.data),
};
